import {createSharedPathnamesNavigation} from 'next-intl/navigation';

export const {
  Link,
  useRouter: useLocalizedRouter,
  usePathname: useLocalizedPathname
} = createSharedPathnamesNavigation({
  locales: ['en', 'sv', 'no']
});
